import { createStyles } from 'antd-style'

export const useStyles = createStyles(
  ({ token }, props: { hasId?: boolean }) => ({
    datePicker: {
      minWidth: 340
    },
    detailsCard: {
      backgroundColor: !props?.hasId
        ? `${token.primary.primary3}1a`
        : 'transparent',
      borderRadius: token.borderRadius,
      border: 'none',
      '.ant-card-body': {
        padding: props?.hasId ? 0 : 24
      }
    },
    table: {
      width: '100%',
      '.ant-table-footer': {
        background: 'white',
        border: 'none !important'
      }
    },
    extraCardStyles: {
      '.ant-card-body': {
        padding: '24px !important'
      }
    },
    producerText: {
      maxWidth: '400px !important',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  })
)
